/**
 * BIDC (parent/iframe) origin handling: target origin for postMessage and allowed origins for validation.
 * Keeps the contract with the PHP parent in one place.
 */

export const BIDC_ALLOWED_ORIGINS = [
  "https://secure.dev.copilotcrm.com",
  "https://secure.staging.copilotcrm.com",
  "https://secure.copilotcrm.com",
] as const;

export function getTargetOrigin(): string {
  if (typeof window === "undefined") return "*";

  if (
    window.location.origin.includes("localhost") ||
    window.location.origin.includes("127.0.0.1")
  ) {
    return "*";
  }

  if (window.location.origin.includes("dev.copilotcrm.com")) {
    return "https://secure.dev.copilotcrm.com";
  }
  if (window.location.origin.includes("staging.copilotcrm.com")) {
    return "https://secure.staging.copilotcrm.com";
  }
  if (window.location.origin.includes("copilotcrm.com")) {
    return "https://secure.copilotcrm.com";
  }

  return "*";
}

export function isAllowedOrigin(origin: string): boolean {
  const isLocalhost =
    origin.startsWith("http://localhost:") ||
    origin.startsWith("http://127.0.0.1:");
  return (
    (BIDC_ALLOWED_ORIGINS as readonly string[]).includes(origin) || isLocalhost
  );
}
